import { render, staticRenderFns } from "./PelatihanPeserta.vue?vue&type=template&id=2bf2a4c1"
import script from "./PelatihanPeserta.vue?vue&type=script&lang=js"
export * from "./PelatihanPeserta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports